import React from "react";
import styles from "./Footer.module.scss";
import logo from "../../../img/header_icon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const footerLinks = [
  {
    href: "https://www.mobilityglobal.com/en-us/legal/licensing-terms",
    label: "Terms of Use",
  },
  {
    href: "https://www.mobilityglobal.com/en-us/privacy",
    label: "Privacy Policy",
  },
  {
    href: "https://www.mobilityglobal.com/en-us/contact-us",
    label: "Customer Care",
  },
];

const Footer = () => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const currentYear = new Date().getFullYear();

  return (
    <div className={`${styles.footer} ${isExpanded ? styles.expanded : ""}`}>
      <button
        type="button"
        className={styles.footerHeader}
        onClick={() => setIsExpanded(!isExpanded)}
        style={{outline: "none"}}
        aria-expanded={isExpanded}
        aria-controls="footer-links-panel"
        aria-label={isExpanded ? "Collapse footer links" : "Expand footer links"}
      >
        <div className={styles.copyRightSection}>
          © {currentYear} Mobility Global All rights reserved. Reproduction in
          whole or in part without permission is prohibited.
        </div>
        <div>
          <FontAwesomeIcon
            className={styles.footerIcon}
            icon={!isExpanded ? faChevronDown : faChevronUp}
            size="2x"
            aria-hidden="true"
          />
        </div>
      </button>
      {isExpanded && (
        <div className={styles.footerBody} id="footer-links-panel">
          <div className={styles.footerLinks}>
            {footerLinks.map((link, index) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                style={{outline:"none"}}
                rel="noopener noreferrer"
                className={`${styles.footerLink} ${
                  index < footerLinks.length - 1 ? styles.footerLinkWithDivider : ""
                }`}
              >
                {link.label}
                <span className={styles.srOnly}> opens in a new tab</span>
              </a>
            ))}
          </div>
          <img
            src={logo}
            alt="Mobility Global Logo"
            className={styles.footerLogo}
          />
        </div>
      )}
    </div>
  );
};

export default Footer;
